export default __webpack_public_path__ + "static/media/2016_award1.63b49651.jpg";